/**
 * @generated SignedSource<<c88f292d894ab3396246d88b6717e98a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItem_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavItemBadge_viewer">;
  readonly " $fragmentType": "NavItem_viewer";
};
export type NavItem_viewer$key = {
  readonly " $data"?: NavItem_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItem_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItemBadge_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "17b100dc9132af630c169010f8a2a471";

export default node;
